import IPayment, { IPaymentState } from "models/IPayment";
import ISite from "models/ISite";
import { IError } from "./models/IError";

export interface IAppState {
    site: Record<string, ISite>;
    loading: boolean;
    error: IError | null;
    preTransaction?: { main?: IPayment; temp?: IPayment };
    paymentState?: IPaymentState;
}
